import React from 'react';
import HotspotImageBlock from './HotspotImageBlock';
import HotspotPointsField from './HotspotPointsField';
import { HOTSPOT_IMAGE_STYLE_SCHEMA } from './hotspotImageStyleSchema';
import { styleDefaults } from '../../../../shared/theme/styleSchema';
import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';
import { puckImageField } from '../../../puck/fields/puckImageField';
import { puckThemeStyleField } from '../../../puck/fields/ThemeStyleSelectField';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { puckColorField, puckPrimaryColorField } from '../../../puck/fields/createPuckColorField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { puckShadowField } from '../../../puck/fields/puckShadowField';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { themedBlockProps, themedBlockResolveData, themedBlockResolveFields } from '../../../puck/themedBlocks';

const hotspotImageConfig = {
  label: 'Image avec repères',
  defaultProps: { src: '', points: [], ...styleDefaults(HOTSPOT_IMAGE_STYLE_SCHEMA) },
  fields: withThemedFieldValues('hotspotImage', {
    _content: puckSectionField('Image et repères'),
    src: puckImageField('Image'),
    alt: { type: 'text', label: 'Description accessible de l’image' },
    points: { type: 'custom', label: 'Repères', render: (props) => <HotspotPointsField {...props} /> },
    _gallery: puckStyleGallerySectionField('Image avec repères'),
    themeStyleId: puckThemeStyleField('hotspotImage'),
    _style: puckSectionField('Présentation'),
    accent: puckPrimaryColorField('Couleur des repères'),
    markerSize: puckPxSpacingField('Taille des repères'),
    border: puckBorderField('Cadre', { readDefaults: () => BORDERLESS_BORDER }),
    shadow: puckShadowField('Ombre'),
    panelBackground: puckColorField('Fond des fenêtres'),
    panelWidth: puckPxSpacingField('Largeur des fenêtres', undefined, { max: 800 }),
    textStyles: puckTextRolesField([{ key: 'title', label: 'Titre des repères' }, { key: 'description', label: 'Explication' }]),
  }),
  resolveData: themedBlockResolveData('hotspotImage'),
  resolveFields: themedBlockResolveFields('hotspotImage'),
  render: (props) => <HotspotImageBlock {...themedBlockProps('hotspotImage', props, props.puck?.metadata)} />,
};

export default hotspotImageConfig;
